import { Navigate } from 'react-router-dom';
import { lazy } from 'react';

const MarketingPage = lazy(() => import('../pages/MarketingPage'));
const FeaturesPage = lazy(() => import('../pages/FeaturesPage'));
const GuidePage = lazy(() => import('../pages/GuidePage'));
const FaqPage = lazy(() => import('../pages/FaqPage'));
const BlogPage = lazy(() => import('../pages/BlogPage'));
const PrivacyPage = lazy(() => import('../pages/PrivacyPage'));
const TermsPage = lazy(() => import('../pages/TermsPage'));
const WelcomePage = lazy(() => import('../pages/WelcomePage'));
const DashboardPage = lazy(() => import('../pages/DashboardPage'));
const BookshelfPage = lazy(() => import('../pages/BookshelfPage'));
const InstallPage = lazy(() => import('../pages/InstallPage'));
const ProvisioningPage = lazy(() => import('../pages/ProvisioningPage'));
const AdminPage = lazy(() => import('../pages/AdminPage.jsx'));
const CurrentStatePage = lazy(() => import('../pages/CurrentStatePage')); // ADDED
const DesignerPage = lazy(() => import('../pages/Designer/index')); // UPDATED — moved to Designer/

const KlippyPage = lazy(() => import('../features/klippy/KlippyPage.jsx'));

import AppLayout from './AppLayout';
import WorkspaceLayout from './WorkspaceLayout'; // ADDED
import CheckoutCancelledPage from '../pages/CheckoutCancelledPage';
import BeforeYouSubscribePage from '../pages/BeforeYouSubscribePage';

// Public routes — rendered inside AppLayout
const publicChildren = [
    { index: true, element: <MarketingPage /> },
    { path: '/guide', element: <GuidePage /> },
    { path: '/faq', element: <FaqPage /> },
    { path: '/features', element: <FeaturesPage /> },
    { path: '/blog', element: <BlogPage /> },
    { path: '/privacy', element: <PrivacyPage /> },
    { path: '/terms', element: <TermsPage /> },
    { path: '/install', element: <InstallPage /> },
    { path: '/checkoutCancelled', element: <CheckoutCancelledPage /> },
    { path: '/before', element: <BeforeYouSubscribePage /> },
    { path: '/klippy', element: <KlippyPage /> },
];

// Authenticated routes inside AppLayout (AppAppBar via AppLayout)
const authenticatedChildren = [
    { path: '/welcome', element: <WelcomePage /> },
    { path: '/provisioning', element: <ProvisioningPage /> },
];

// Workspace routes — rendered inside WorkspaceLayout (fullscreen, no AppAppBar)
const workspaceChildren = [
    { path: '/currentstate', element: <CurrentStatePage /> }, // ADDED
    { path: '/designer', element: <DesignerPage /> }, // ADDED
];

export const getRoutes = (isSignedIn) => [
    {
        path: '/',
        element: <AppLayout />,
        children: [...publicChildren, ...(isSignedIn ? authenticatedChildren : [])],
    },
    // Dashboard is standalone — has its own AppAppBar, no AppLayout wrapper
    ...(isSignedIn ? [{ path: '/dashboard', element: <DashboardPage /> }] : []),
    // Bookshelf is standalone — same pattern as Dashboard, own AppAppBar
    ...(isSignedIn ? [{ path: '/bookshelf', element: <BookshelfPage /> }] : []),
    // Workspace pages — fullscreen, no AppAppBar, WorkspaceLayout wraps all workspace routes
    ...(isSignedIn ? [{ path: '/', element: <WorkspaceLayout />, children: workspaceChildren }] : []), // ADDED
    // Admin is standalone — always accessible regardless of siteConfig or auth state
    { path: '/admin', element: <AdminPage /> },
    {
        path: '*',
        element: <Navigate to="/" />,
    },
];
